<template>
  <modal-template
    v-on:cancel="onCancel"
    v-on:accept="onAccept"
    :back-text="modalData.backText"
    :accept-text="modalData.acceptText"
    :alert-modal="modalData.alertModal"
    :enable-accept="enableAccept"
    :important="modalData.important"
    :showTemplateButtons="modalData.showTemplateButtons"
    :show-accept="modalData.showAccept"
    :modalComponentName="modalComponent && modalComponent.name"
  >
    <component
      v-if="modalComponent"
      v-bind:is="modalComponent"
      v-on:enable-accept="onEnableAccept"
      :modal-data="modalData"
      ref="AppModalChild"
    />
  </modal-template>
</template>

<script>
import { mapState } from 'vuex'
import ModalTemplate from './ModalTemplate.vue'
import RejoinSessionModal from './RejoinSessionModal.vue'
import SubjectSelectionModal from '@/views/DashboardView/StudentDashboard/SubjectSelection/SubjectSelectionModal.vue'
import NotificationsModal from '@/views/DashboardView/StudentDashboard/SubjectSelection/NotificationsModal.vue'
import ReferralModal from '@/views/DashboardView/StudentDashboard/ReferralModal.vue'
import SessionFulfilledModal from '@/views/SessionView/SessionFulfilledModal.vue'
import VolunteerOnboardingModal from '@/views/DashboardView/VolunteerDashboard/VolunteerOnboardingModal.vue'
import StudentOnboardingModal from '@/views/DashboardView/StudentDashboard/StudentOnboardingModal.vue'
import ReportSessionModal from '@/views/SessionView/ReportSessionModal.vue'
import StartCollegeSessionModal from '@/views/DashboardView/StudentDashboard/StartCollegeSessionModal.vue'

export default {
  components: {
    ModalTemplate,
    RejoinSessionModal,
    SubjectSelectionModal,
    NotificationsModal,
    ReferralModal,
    SessionFulfilledModal,
    VolunteerOnboardingModal,
    StudentOnboardingModal,
    ReportSessionModal,
    StartCollegeSessionModal,
  },
  data() {
    return {
      enableAccept: false,
    }
  },
  computed: {
    ...mapState({
      modalComponent: state => state.app.modal.component,
      modalData: state => state.app.modal.data,
    }),
  },
  mounted() {
    // enable the accept button by default if an alert modal
    this.enableAccept = !!this.modalData.alertModal
  },
  methods: {
    onCancel() {
      const child = this.$refs.AppModalChild
      if (child.onCancel) child.onCancel()
    },
    onAccept() {
      const child = this.$refs.AppModalChild
      if (child.onAccept) child.onAccept()
    },
    onEnableAccept(value) {
      this.enableAccept = value
    },
  },
}
</script>
